import { render, staticRenderFns } from "./Rating1To5DashboardItem.vue?vue&type=template&id=75f67c52"
import script from "./Rating1To5DashboardItem.vue?vue&type=script&lang=js"
export * from "./Rating1To5DashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f67c52')) {
      api.createRecord('75f67c52', component.options)
    } else {
      api.reload('75f67c52', component.options)
    }
    module.hot.accept("./Rating1To5DashboardItem.vue?vue&type=template&id=75f67c52", function () {
      api.rerender('75f67c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/Rating1To5DashboardItem.vue"
export default component.exports